/* eslint-disable react-hooks/exhaustive-deps */
import Screen from '@/src/components/Screen';
// import Tabs from "@/src/components/Tabs/Tabs";
import { Label, textVariants } from '@/src/components/Text/Text';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/src/components/shad/select';
import { useCoinData } from '@/src/hooks/useCoinData';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import BuyPayments from './components/BuyPayments';
import api, {
  formatNumber,
  getUniqueArrayByKey,
  removeUndefinedAndNull,
} from '@/src/utils';
import apiRoutes from '@/src/apiRoutes';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@/src/components/Button/Button';
import Preview from './components/Preview';
import useUrlState from '@/src/hooks/use-url-state';
import { isEmpty } from 'lodash';
import SellPayments from './components/SellPayments';
import TradeInput from '@/src/components/TradeInput';
import exclam from '@assets/exclamation.svg';
import { Modal } from '@/src/components/Modal/Modal';
import TradeSuccess from './components/TradeSuccess';
import CoinPrice from './components/CoinPrice';
import { cn } from '@/lib/utils';
import TransferVertical from '@/src/svg/transferVertical';
import FilledCheck from '@/src/svg/filledCheck';
import EmptyCheck from '@/src/svg/emptyCheck';
import { useTheme } from '@/src/context/themeContext';
import { useAppDispatch } from '@/src/app/hooks';
import { clearBeneficiaryPayment } from '@/src/features/tradeSlice';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TOptions } from 'i18next';
import { Combobox } from '@/src/components/combobox';
import { useCoinBalance } from '@/src/hooks/useCoinBalance';

const buySellState = z.object({
  coin: z.string(),
  amount: z
    .number({
      required_error: 'Amount is required',
      invalid_type_error: 'Amount must be a number',
    })
    .positive({ message: 'This field requires a positive number' }),
  buySell: z.string(),
  payment: z.number().optional(),
  coin_id: z.string(),
  currency: z.string(),
  deposit_local: z.boolean(),
  address: z.string().optional(),
  crypto_val: z.string(),
  fiat: z.boolean(),
});

export type tradeType = z.infer<typeof buySellState>;

export type sellPaymentType = {
  service_id: number;
  account_name: string;
  account_number: string;
  id: string | undefined;
  image: string | undefined;
  service_name: string | undefined;
  amount: number;
  personal_business: string;
};

const DirectTrade = () => {
  const { t } = useTranslation();
  const trans = (key?: string, options?: TOptions) =>
    t(`app.buysell.${key}`, options);
  const [previewInfo, setPreviewInfo] = useState<
    TradeDirectPreviewInfo | undefined
  >(undefined);
  const { trade_type } = useParams();
  const [network, setNetwork] = useState<string | null>(null);
  const [tradeSuccess, setTradeSuccess] = useUrlState('trade_success');
  const [tradeSuccessMessage, setTradeSuccessMessage] = useState('');
  const [sellPayments, setSellPayments] = useState<
    Array<sellPaymentType> | undefined
  >([]);
  const [accumulatedAmount, setAccumulatedAmount] = useState(0);
  const [openPreview, setOpenPreview] = useState(false);
  const { theme } = useTheme();
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  const buySell = trade_type;

  const { register, setValue, watch, getValues } = useForm<tradeType>({
    mode: 'onBlur',
    resolver: zodResolver(buySellState),
    defaultValues: {
      fiat: true,
      currency: undefined,
      buySell: 'buy',
      deposit_local: false,
      // crypto_val: "0",
    },
  });
  const { coinData, isSuccess } = useCoinData({
    allow_buy: buySell === 'buy' ? true : false,
    allow_sell: buySell === 'sell' ? true : false,
  });

  console.log('coinData on sell', coinData);

  const singleCrypto =
    coinData?.find((item) => item.coin__id.toString() === watch('coin_id')) ??
    coinData?.[0];

  console.log('singleCrypto', singleCrypto);

  const tickerInstance = coinData?.filter(
    (item) => item?.coin__ticker === singleCrypto?.coin__ticker
  );

  console.log('tickerInstance', tickerInstance);

  const uniqueCoins =
    coinData && getUniqueArrayByKey<CoinRate>(coinData as [], 'coin__ticker');

  // fn to  get data to populate the forms
  const getComponents = async () => {
    // slice after the third value to get the country_id
    const country_id = !isEmpty(currency) ? currency?.slice(3) : '';
    const res = await api.post(apiRoutes.components, {
      trans_type: buySell,
      country: Number(country_id),
    });
    return res.data?.info;
  };

  const {
    data: components,
    isLoading,
    refetch,
  } = useQuery<ComponentsInfo>({
    queryKey: ['get_components', watch('currency'), buySell],
    queryFn: getComponents,
    onSuccess: (data) => {
      if (data) {
        if (!watch('currency')) {
          // Set initial currency with a value of currency code plus the currency id
          setValue(
            'currency',
            data?.currencies[0]?.currency + data?.currencies[0]?.id.toString()
          );
        }
      }
    },
  });

  const coinId = watch('coin_id');
  const currency = watch('currency');
  const selectedPayment = watch('payment');
  const selectedCoin = coinData?.find(
    (item) => item?.coin__id.toString() === coinId
  );

  const checkRateFunc = async () => {
    const res = await api.post(
      apiRoutes.tradePreview,
      buySell === 'buy'
        ? {
            currency: getValues().currency?.slice(0, 3),
            amount: watch('fiat')
              ? getValues()?.amount
              : getValues()?.crypto_val,
            coin: network ? Number(network) : Number(getValues()?.coin_id),
            payment_id: Number(getValues()?.payment),
            trans_type: buySell,
            deposit_local: getValues()?.deposit_local,
            fiat: watch('fiat'),
            address: getValues('address'),
            network: coinData?.find(
              (item) =>
                item?.coin__id === Number(network ? network : watch('coin_id'))
            )?.coin__network,
          }
        : {
            currency: getValues().currency?.slice(0, 3),
            amount: watch('fiat')
              ? getValues()?.amount
              : getValues()?.crypto_val,
            coin: network ? Number(network) : Number(getValues()?.coin_id),
            // payment_id: Number(getValues()?.payment),
            trans_type: buySell,
            fiat: watch('fiat'),
            beneficiaries: sellPayments?.map((item) => {
              return removeUndefinedAndNull({
                service_id: item?.service_id,
                account_name: item?.account_name,
                account_number: item?.account_number,
                amount:
                  sellPayments.length > 1
                    ? item?.amount
                    : (watch('amount') as number),
                agent:
                  item?.service_name?.toLocaleLowerCase() === 'mtn' &&
                  item?.personal_business === 'Agent Number'
                    ? true
                    : undefined,
              });
            }),
            network: coinData?.find(
              (item) =>
                item?.coin__id === Number(network ? network : watch('coin_id'))
            )?.coin__network,
          }
    );
    return res?.data;
  };

  const checkRate = useMutation({
    mutationFn: checkRateFunc,
    onSuccess: (data) => {
      if (data?.success) {
        setOpenPreview(true);
        setPreviewInfo(data?.info);
        // setValue("crypto_val", data?.info?.amt_to_receive_crypto.split(" ")[0]);
      } else {
        toast.warning(data?.info);
        setPreviewInfo(undefined);
      }
    },
  });

  const trade = async () => {
    // const codeExists = code.length > 0 ? { code } : {};
    const res = await api.post(apiRoutes.initiateTrade);
    return res.data;
  };

  const { mutate: mutateInitate, isLoading: tradeLoad } = useMutation({
    mutationFn: trade,
    onSuccess: (data) => {
      if (data?.success) {
        setOpenPreview(false);

        if (typeof data?.info !== 'string') {
          if (data?.info?.url !== null) {
            window.location.assign(data?.info?.url);
          }
        } else {
          toast.success(data?.info);
          setTradeSuccess('open');
          queryClient.invalidateQueries({
            queryKey: ['check_enablers_active_trades'],
          });
          if (buySell === 'sell') {
            dispatch(clearBeneficiaryPayment());
            setTradeSuccessMessage(data?.info);
          }
        }
      } else {
        toast.warning(data?.info);
      }
    },
  });

  // const sendCode = async () => {
  //   const res = await api.post(apiRoutes.initiateTrade, {
  //     type: "request",
  //   });
  //   return res.data;
  // };

  // const { mutate: mutateSendCode, isLoading: sendCodeLoad } = useMutation({
  //   mutationKey: ["send_sell_code"],
  //   mutationFn: sendCode,
  //   onSuccess: (data) => {
  //     if (data?.success) {
  //       setTradeSuccess("open");
  //       setTradeSuccessMessage(data?.info);
  //     }
  //   },
  // });

  const rateToShow = components?.rates.find(
    (item) => item?.coin__id.toString() === watch('coin_id')
  );

  const coin = coinData?.find(
    (item) => item.coin__id.toString() === watch('coin_id')
  );

  // Effect to clear previewdata when amount type changes
  useEffect(
    function changeToCryptoVal() {
      if (!isEmpty(watch('fiat')) || !isEmpty(watch('crypto_val'))) {
        setPreviewInfo(undefined);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [previewInfo, watch('fiat')]
  );

  useEffect(
    function clearAllValues() {
      if (buySell) {
        setValue('payment', undefined);
        setValue('address', '');
        setPreviewInfo(undefined);
        setSellPayments([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [buySell]
  );

  useEffect(
    function setDefaultCoin() {
      if (isSuccess && coinData) {
        setValue('coin_id', coinData[0].coin__id.toString());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isSuccess]
  );

  useEffect(
    function clearNetworkWhenCoinChange() {
      setNetwork(null);
    },
    [watch('coin_id')]
  );

  const { balance } = useCoinBalance(
    network ? Number(network) : Number(watch('coin_id'))
  );

  // if (isLoading || currencyLoad) return null

  return (
    <Screen loading={isLoading}>
      <h2
        className={cn(
          textVariants({ font: 'semibold' }),
          'md:text-4xl text-xl'
        )}
      >
        {' '}
        <span>
          {buySell === 'buy'
            ? t('app.buysell.buyHeader')
            : t('app.buysell.sellHeader')}
        </span>
      </h2>
      <div className='my-3 flex items-center justify-between md:justify-start md:space-x-20 '></div>
      <div className='grid lg:grid-cols-5 gap-10 md:gap-5 '>
        <div className='lg:col-span-3 flex flex-col gap-4'>
          {buySell === 'buy' && (
            <div className='grid md:grid-cols-2 gap-4'>
              <div>
                <TradeInput
                  {...register('address')}
                  disabled={watch('deposit_local')}
                  label={t('app.buysell.forms.address.label')}
                  className='placeholder:text-xs md:placeholder:text-base'
                  // placeholder={t("app.buysell.forms.address.placeholder")}
                  placeholder={trans('forms.address.placeholder', {
                    coin: coin?.coin__label,
                  })}
                />
                {components?.local_deposit && (
                  <div className='flex items-center gap-2 mt-1  '>
                    {/* <input {...register('deposit_local')} type="checkbox" /> */}
                    <div
                      className='cursor-pointer'
                      onClick={() =>
                        setValue('deposit_local', !watch('deposit_local'))
                      }
                    >
                      {watch('deposit_local') ? (
                        <FilledCheck height={18} width={18} />
                      ) : (
                        <EmptyCheck height={18} width={18} />
                      )}
                    </div>
                    <span
                      className={cn(
                        'text-infoblue-500 dark:text-infoblue-200 text-sm'
                      )}
                    >
                      {t('app.buysell.forms.address.buyInternal')}
                    </span>
                  </div>
                )}
              </div>
              {/* <div className="flex items-center w-full"> */}
              {components?.currencies && (
                <div className=' rounded-xl w-full '>
                  <Label>{t('app.buysell.forms.currency.label')}</Label>
                  <Select
                    value={watch('currency')}
                    onValueChange={(val) => setValue('currency', val)}
                  >
                    <SelectTrigger className='focus:outline-none flex whitespace-nowrap py-6 rounded-xl'>
                      <SelectValue placeholder='Currency' />
                    </SelectTrigger>
                    <SelectContent>
                      {components?.currencies?.map((currency) => (
                        <SelectItem
                          key={currency?.id}
                          // Value to append the id to the currency code to make it unique
                          value={currency?.currency + currency?.id.toString()}
                        >
                          <div className='flex items-center gap-2'>
                            <img
                              src={currency?.image}
                              alt={currency?.id.toString()}
                              className='h-4 w-4'
                            />
                            <span>
                              {currency?.name}({currency?.currency})
                            </span>
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}
            </div>
            // </div>
          )}

          {components?.currencies && uniqueCoins && (
            <div className=' grid md:grid-cols-2 gap-4 mb-4'>
              <div
                className={cn('w-full ', buySell === 'sell' && 'md:col-span-2')}
              >
                <Label>{t('app.buysell.forms.crypto.label')}</Label>
                <Select
                  value={watch('coin_id')}
                  onValueChange={(val) => setValue('coin_id', val)}
                >
                  <SelectTrigger className='focus:outline-none focus:ring-0 py-[26px] text-lg rounded-xl'>
                    <SelectValue
                      className='text-gray-500 '
                      placeholder='Eg. Bitcoin'
                    />
                  </SelectTrigger>
                  <SelectContent>
                    {uniqueCoins?.map((coin) => (
                      <SelectItem
                        key={coin?.coin__id}
                        value={coin?.coin__id.toString()}
                      >
                        <div className='flex items-center gap-2'>
                          <img
                            className='h-5 w-5'
                            src={coin?.coin__image}
                            alt={coin?.coin__ticker}
                          />
                          <span>{coin?.coin__label}</span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {tickerInstance && tickerInstance?.length === 1 && (
                  <div className='flex '>
                    <div className='flex gap-1'>
                      <span className='text-infoblue-500 dark:text-infoblue-200 font-bold text-sm'>
                        USD {formatNumber(balance?.info.fiat ?? 0) ?? 0}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {tickerInstance && tickerInstance?.length > 1 && (
                <div>
                  <Label>{t('app.wallet.withdraw.form.network.label')}</Label>
                  <Combobox
                    triggerClassName='h-14 rounded-xl'
                    items={tickerInstance?.map((item) => ({
                      value: item?.coin__id.toString(),
                      render: (
                        <div
                          key={item?.coin__id}
                          className='flex items-center justify-between w-full '
                        >
                          <div className='flex items-center gap-2'>
                            <img
                              src={
                                item?.coin__network_image ?? item?.coin__image
                              }
                              alt={item?.coin__ticker}
                              className='h-6 w-6'
                            />
                            <div className='grid'>
                              <span>{`${item?.coin__label} ${item?.coin__network_label}`}</span>
                              <span
                                className={cn(
                                  'text-left',
                                  textVariants({ size: 'xs' })
                                )}
                              >
                                {item?.coin__description}
                              </span>
                            </div>
                          </div>
                          <div>
                            {item?.coin__recommended && (
                              <span className='px-2 py-0.5 rounded-2xl bg-indigo-200 text-indigo-400 text-[8px] md:text-xs'>
                                Recommended
                              </span>
                            )}
                          </div>
                        </div>
                      ),
                      searchText:
                        item?.coin__ticker + item?.coin__network_label,
                    }))}
                    emptyMessage='No items found.'
                    placeholder={t(
                      'app.wallet.withdraw.form.network.placeholder',
                      {
                        coin: coin?.coin__label,
                      }
                    )}
                    onChange={(val) => setNetwork(val)}
                  />
                  {tickerInstance && tickerInstance?.length > 1 && (
                    <div className='flex '>
                      <div className='flex gap-1'>
                        <span className='text-infoblue-500 dark:text-infoblue-200 font-bold text-sm'>
                          USD {formatNumber(balance?.info.fiat ?? 0)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className={cn(buySell === 'buy' && 'hidden')}>
                <Label>{t('app.buysell.forms.currency.label')}</Label>
                <Select
                  value={watch('currency')}
                  onValueChange={(val) => setValue('currency', val)}
                >
                  <SelectTrigger className='focus:outline-none whitespace-nowrap py-6 rounded-xl '>
                    <SelectValue placeholder='Currency' />
                  </SelectTrigger>
                  <SelectContent>
                    {components?.currencies?.map((currency) => (
                      <SelectItem
                        key={currency?.id}
                        // Value to append the id to the currency code to make it unique
                        value={currency?.currency + currency?.id.toString()}
                      >
                        <div className='flex items-center gap-2 mr-3'>
                          <img
                            src={currency?.image}
                            alt={currency?.id.toString()}
                            className='h-4 w-4'
                          />
                          <span>
                            {currency?.name}({currency?.currency})
                          </span>
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div
                className={cn(
                  tickerInstance &&
                    tickerInstance?.length > 1 &&
                    'md:col-span-2',
                  'relative'
                )}
              >
                <TradeInput
                  min={0}
                  placeholder={t('app.buysell.forms.amount.placeholder')}
                  label={
                    buySell === 'buy'
                      ? t('app.buysell.forms.amount.buylabel')
                      : t('app.buysell.forms.amount.selllabel')
                  }
                  type={'number'}
                  {...register(watch('fiat') ? 'amount' : 'crypto_val', {
                    valueAsNumber: true,
                  })}
                  right={
                    buySell === 'buy' ? (
                      <div
                        onClick={() =>
                          setValue('fiat', watch('fiat') ? false : true)
                        }
                        className=' flex items-center justify-center cursor-pointer h-full px-2 pr-4'
                      >
                        {/* <ArrowUpDown className="h-5 w-5 rotate-45 text-gray-600 dark:text-white" /> */}
                        <TransferVertical
                          color={theme === 'dark' ? 'white' : undefined}
                          height={24}
                          width={24}
                        />
                        <div className='grid'>
                          <span className='uppercase font-bold text-gray-600 dark:text-white  text-sm'>
                            {watch('fiat')
                              ? watch('currency')?.slice(0, 3)
                              : selectedCoin?.coin__ticker}
                          </span>
                          <span className='uppercase  text-gray-600 dark:text-white text-end  text-[11px]'>
                            {watch('fiat')
                              ? selectedCoin?.coin__ticker
                              : watch('currency')?.slice(0, 3)}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className=' flex items-center justify-center gap-1 cursor-pointer h-full px-2'>
                        <span className='uppercase font-bold text-gray-600 dark:text-white text-sm '>
                          <span>{watch('currency')?.slice(0, 3)}</span>
                        </span>
                      </div>
                    )
                  }
                />
                {rateToShow && (
                  <div className='flex justify-end absolute left-0'>
                    <div className='flex gap-1'>
                      <img
                        src={exclam}
                        className='h-5 w-5 rounded-full rotate-180'
                        alt='icon'
                      />
                      <span className='text-infoblue-500 dark:text-infoblue-200 font-bold text-sm'>
                        <span className='capitalize'>
                          {t('app.buysell.forms.rate.label')} $1.00 =
                        </span>

                        {buySell === 'buy'
                          ? ` ${rateToShow?.country__symbol} ${rateToShow?.buy}`
                          : ` ${rateToShow?.country__symbol} ${rateToShow?.sell}`}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {watch('currency') && buySell === 'buy' && (
            <BuyPayments
              paymentMethods={components?.payment_methods}
              setValue={setValue}
              selectedPayment={selectedPayment}
            />
          )}

          {watch('currency') && buySell === 'sell' && watch('amount') > 0 && (
            <SellPayments
              amount={watch('amount')}
              paymentMethods={components?.payment_methods}
              setValue={setSellPayments}
              selectedPayment={sellPayments}
              accAmount={accumulatedAmount}
              setAccAmount={setAccumulatedAmount}
              currency={watch('currency')}
              refetchComponents={refetch}
            />
          )}

          {/* {!previewInfo && ( */}
          <div>
            <Button
              className='w-full'
              disabled={
                (buySell === 'buy'
                  ? !watch('payment')
                  : isEmpty(sellPayments)) ||
                (sellPayments &&
                  sellPayments?.length > 1 &&
                  accumulatedAmount !== watch('amount')) ||
                (tickerInstance &&
                  tickerInstance?.length > 1 &&
                  network === null)
              }
              loading={checkRate.isLoading}
              onClick={() => checkRate.mutate()}
            >
              {t('app.buysell.forms.previewButton')}
            </Button>
          </div>
          {/* )} */}
          <Modal open={openPreview} setOpen={setOpenPreview} setter='state'>
            <>
              <Preview
                coin={selectedCoin}
                previewInfo={previewInfo}
                tradeType={buySell as string}
                selectedPayment={selectedPayment}
                paymentMethods={components?.payment_methods}
                sellPayments={sellPayments}
              />
              {/* {codeState === "success" && (
                <EnterCode code={code} setCode={setCode} />
              )} */}
              {previewInfo && (
                <div className='mt-5'>
                  <Button
                    loading={tradeLoad}
                    onClick={() => mutateInitate()}
                    className='w-full'
                  >
                    {t('app.buysell.preview.continueButton')}
                  </Button>
                </div>
              )}
            </>
          </Modal>
        </div>
        <div className='lg:col-span-2'>
          <CoinPrice />
        </div>
      </div>

      <Modal
        open={tradeSuccess === 'open'}
        setOpen={(val) => setTradeSuccess(val ? undefined : 'open')}
      >
        <TradeSuccess type={buySell as string} message={tradeSuccessMessage} />
      </Modal>
    </Screen>
  );
};

export default DirectTrade;

// export const EnterCode = ({
//   code,
//   setCode,
// }: {
//   code: string;
//   setCode: React.Dispatch<React.SetStateAction<string>>;
// }) => {
//   return (
//     <div>
//       <form>
//         <InputComponent
//           value={code}
//           onChange={(e) => setCode(e.target.value)}
//           label="Enter the 2FA code sent to your email"
//         />
//       </form>
//     </div>
//   );
// };
